import { injectable, inject } from 'inversify';
import AsyncHeadersSupportingFetchAdapter from './adapters/AsyncHeadersSupportingFetchAdapter';
import Container from '@framework/di/Container';
import { IAdapterFactory as IAdapterFactoryBase } from '@framework/di/Providers/Rpc/IAdapterFactory';

@injectable()
class AdapterFactory implements IAdapterFactoryBase {
  constructor(
    @inject(Container) private readonly container: Container,
  ) {}

  create(url: string, options?: { otelPropagation: boolean }) {
    return new AsyncHeadersSupportingFetchAdapter(
      url,
      {
        container: this.container,
        otelPropagation: options?.otelPropagation,
      });
  }
}

export default AdapterFactory;
